var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orders)?_c('div',{staticClass:"section__lk-content-items mt-0"},[(_vm.orders.length)?_c('div',{staticClass:"section__lk-content-items-title"},[_vm._v(" Заявки ")]):_vm._e(),_vm._l((_vm.orders),function(order){return [_c('seminar-order-list-item',{key:order.id,attrs:{"order":order}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }